import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo56 from './56logo.png';

const Services = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Scroll event listener for header buttons
  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setIsScrolled(scrollTop > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const services = [
    // LASTİK HİZMETLERİ
    {
      id: 1,
      name: 'Lastik Takımı ve Değişimi',
      category: 'LASTİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      description: 'Profesyonel lastik takım ve değişim hizmeti ile aracınızı güvenle yola çıkarın',
      features: ['Hızlı montaj', 'Güvenli takım', 'Kaliteli malzeme']
    },
    {
      id: 2,
      name: 'Montaj Balans',
      category: 'LASTİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ),
      description: 'Lastik montajı sonrası profesyonel balans ayarı ile titreşimsiz sürüş',
      features: ['Hassas balans', 'Titreşim giderme', 'Uzun ömür']
    },
    {
      id: 3,
      name: 'Lastik Onarımı',
      category: 'LASTİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
      description: 'Lastik patlaklarında profesyonel onarım hizmeti',
      features: ['Kalıcı onarım', 'Güvenli yama', 'Hızlı çözüm']
    },
    {
      id: 4,
      name: 'Acil Lastik Servisi',
      category: 'LASTİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      ),
      description: '7/24 acil lastik değişim ve onarım hizmeti',
      features: ['24 saat hizmet', 'Hızlı müdahale', 'Mobil servis']
    },

    // TEKNİK HİZMETLER
    {
      id: 5,
      name: '4 Kafa Rot Ayarı',
      category: 'TEKNİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2" />
        </svg>
      ),
      description: 'Modern 4 kafa rot ayar cihazı ile hassas rot ayarı',
      features: ['4 kafa sistem', 'Hassas ölçüm', 'Uzun lastik ömrü']
    },
    {
      id: 6,
      name: 'Balans ve Rot Ayarı',
      category: 'TEKNİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
        </svg>
      ),
      description: 'Lastik balansı ve rot ayarı ile düzgün sürüş',
      features: ['Balans ayarı', 'Rot kontrolü', 'Direksiyon titreşimi giderme']
    },
    {
      id: 7,
      name: 'Sensör Arıza Giderimi',
      category: 'TEKNİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      description: 'Lastik basınç sensörü arıza tespiti ve onarımı',
      features: ['Sensör kontrolü', 'Arıza tespiti', 'Onarım hizmeti']
    },
    {
      id: 8,
      name: 'Arıza Tespiti',
      category: 'TEKNİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      description: 'Lastik ve jant arızalarında detaylı teşhis hizmeti',
      features: ['Detaylı inceleme', 'Arıza tespiti', 'Çözüm önerileri']
    },
    {
      id: 15,
      name: 'Nitrojen Dolumu',
      category: 'TEKNİK',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      description: 'Lastiklerinize nitrojen dolumu ile uzun ömür ve stabil basınç',
      features: ['Uzun ömür', 'Stabil basınç', 'Yakıt tasarrufu']
    },

    // SATIŞ HİZMETLERİ
    {
      id: 9,
      name: 'Perakende Satış',
      category: 'SATIŞ',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
        </svg>
      ),
      description: 'Bireysel müşteriler için lastik satış hizmeti',
      features: ['Geniş lastik seçeneği', 'Uygun fiyat', 'Kaliteli markalar']
    },
    {
      id: 10,
      name: 'Toptan Satış',
      category: 'SATIŞ',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
      description: 'Galeri ve servislere özel toptan satış hizmeti',
      features: ['Toptan fiyat', 'Stok garantisi', 'Hızlı teslimat']
    },
    {
      id: 11,
      name: 'Akü Satış Hizmeti',
      category: 'SATIŞ',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      description: 'Kaliteli akü satış ve takım hizmeti',
      features: ['Kaliteli aküler', 'Ücretsiz takım', 'Garanti hizmeti']
    },

    // ÖZEL HİZMETLER
    {
      id: 12,
      name: 'Lastik Oteli',
      category: 'ÖZEL',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2H5a2 2 0 00-2-2v0a2 2 0 002-2h6l2 2h6a2 2 0 012 2v2" />
        </svg>
      ),
      description: 'Lastiklerinizi güvenli şekilde saklama hizmeti',
      features: ['Güvenli depolama', 'Mevsimlik hizmet', 'Temizlik dahil']
    },
    {
      id: 13,
      name: 'Araç Kontrolü',
      category: 'ÖZEL',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      description: 'Lastik ve jant kontrolü ile genel araç muayenesi',
      features: ['Lastik kontrolü', 'Jant muayenesi', 'Güvenlik kontrolü']
    },
    {
      id: 14,
      name: 'Lastik Satış Servis',
      category: 'ÖZEL',
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      ),
      description: 'Kapsamlı lastik satış ve servis hizmeti',
      features: ['Satış+servis', 'Tek nokta çözümü', 'Profesyonel hizmet']
    }
  ];

  return (
    <>
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-lg">
        <div className="container mx-auto px-6">
          <div className="flex justify-between items-center py-0">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center p-2">
                <img src={logo56} alt="N56OTOLASTİK Logo" className="w-full h-full object-contain" />
              </div>
            </Link>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex space-x-6">
              <Link to="/" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                ANA SAYFA
              </Link>
              <Link to="/servisler" className="transition-all duration-300 font-medium text-lg text-red-600 hover:text-red-600">
                SERVİSLER
              </Link>
              <Link to="/neden-biz" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                NEDEN BİZ
              </Link>
              <Link to="/markalar" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                MARKALAR
              </Link>
              <Link to="/hakkimizda" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                HAKKIMIZDA
              </Link>
              <Link to="/iletisim" className="transition-all duration-300 font-medium text-lg text-black hover:text-red-600">
                İLETİŞİM
              </Link>
            </div>

            {/* Mobile Navigation */}
            <div className="md:hidden flex items-center">
              <button
                onClick={toggleMobileMenu}
                className="text-black hover:text-red-600 focus:outline-none"
                aria-label="Toggle menu"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  {isMobileMenuOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                  )}
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile Menu Dropdown */}
          {isMobileMenuOpen && (
            <div className="md:hidden bg-white border-t border-gray-200 py-4">
              <div className="flex flex-col space-y-4">
                <Link 
                  to="/" 
                  className="text-black hover:text-red-600 transition-colors duration-300 font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  ANA SAYFA
                </Link>
                <Link 
                  to="/servisler" 
                  className="text-red-600 hover:text-red-600 transition-colors duration-300 font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  SERVİSLER
                </Link>
                <Link 
                  to="/neden-biz" 
                  className="text-black hover:text-red-600 transition-colors duration-300 font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  NEDEN BİZ
                </Link>
                <Link 
                  to="/markalar" 
                  className="text-black hover:text-red-600 transition-colors duration-300 font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  MARKALAR
                </Link>
                <Link 
                  to="/hakkimizda" 
                  className="text-black hover:text-red-600 transition-colors duration-300 font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  HAKKIMIZDA
                </Link>
                <Link 
                  to="/iletisim" 
                  className="text-black hover:text-red-600 transition-colors duration-300 font-medium"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  İLETİŞİM
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>

      <section className="bg-gray-50 py-16 pt-32">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-4" data-aos="fade-up">
            HİZMETLERİMİZ
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-aos="fade-up" data-aos-delay="200">
            Profesyonel lastik hizmetleri ve teknik destek ile yanınızdayız
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={service.id} className="bg-white rounded-lg shadow-lg overflow-hidden group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white group-hover:bg-red-700 transition-colors duration-300">
                    {service.icon}
                  </div>
                  <span className="bg-red-100 text-red-600 px-3 py-1 rounded-full text-xs font-semibold">
                    {service.category}
                  </span>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.name}</h3>
                <p className="text-gray-600 mb-4">{service.description}</p>
                
                <div className="mb-4">
                  {service.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center text-sm text-gray-500 mb-1">
                      <svg className="w-4 h-4 text-red-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-16 bg-gradient-to-r from-red-600 to-red-800 rounded-lg p-8 text-white" data-aos="fade-up" data-aos-delay="200">
          <h3 className="text-3xl font-bold mb-4" data-aos="fade-up" data-aos-delay="400">
            Hemen Randevu Alın
          </h3>
          <p className="text-red-100 mb-6" data-aos="fade-up" data-aos-delay="600">
            Profesyonel hizmetlerimizden yararlanmak için bizi arayın.
          </p>
          <div className="flex justify-center" data-aos="fade-up" data-aos-delay="800">
            <button className="bg-white hover:bg-gray-100 text-red-600 px-8 py-3 rounded-lg font-semibold transition-colors duration-300">
              0544 56 256 56
            </button>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="mt-16">
          <div className="text-center mb-12">
            <h3 className="text-xl sm:text-2xl md:text-3xl font-bold text-black mb-4" data-aos="fade-up">
              NEDEN N56OTOLASTİK?
            </h3>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="200">
              1967'den bu yana lastik sektöründe hizmet veren tecrübeli ekibimiz ve modern teknolojimizle yanınızdayız
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300" data-aos="fade-up" data-aos-delay="100">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4 className="text-xl font-bold text-black mb-2">Hızlı Servis</h4>
              <p className="text-gray-600">Randevusuz hızlı hizmet anlayışı</p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300" data-aos="fade-up" data-aos-delay="200">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4 className="text-xl font-bold text-black mb-2">Profesyonel Ekip</h4>
              <p className="text-gray-600">Uzman teknisyenler ve deneyimli personel</p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300" data-aos="fade-up" data-aos-delay="300">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h4 className="text-xl font-bold text-black mb-2">Modern Teknoloji</h4>
              <p className="text-gray-600">4 kafa rot cihazı ve gelişmiş ekipmanlar</p>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 text-center hover:shadow-xl transition-shadow duration-300" data-aos="fade-up" data-aos-delay="400">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h4 className="text-xl font-bold text-black mb-2">Uygun Fiyat</h4>
              <p className="text-gray-600">Kaliteli hizmet, makul fiyat</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Services; 